import { Container, Grid, Typography } from '@mui/material';
import { ErrorDto } from '../error-full-page/error-full-page.component';

export function ErrorInline({ error, open }: { open: boolean; error: ErrorDto }) {
  const title = typeof error.title === 'function' ? error.title() : error.title;
  const message = typeof error.message === 'function' ? error.message() : error.message;
  return open ? (
    <Container>
      <Grid container spacing={2} sx={{ flexDirection: 'column' }}>
        <Grid>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Grid>
          <Typography>{message}</Typography>
        </Grid>
      </Grid>
    </Container>
  ) : null;
}
